import { render, staticRenderFns } from "./LogisticsChartTitleRow.vue?vue&type=template&id=8ae17a3a&scoped=true"
import script from "./LogisticsChartTitleRow.vue?vue&type=script&lang=js"
export * from "./LogisticsChartTitleRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae17a3a",
  null
  
)

export default component.exports